module.exports = __webpack_public_path__ + "static/img/momokawa.b26042b9.png";